import Marquee from "react-fast-marquee";
import { Zap } from "lucide-react";

const ITEMS = [
  "PRONTO INTERVENTO 24H",
  "ELETTRIKPRO",
  "NAPOLI E PROVINCIA",
  "PREVENTIVI GRATUITI",
  "INTERVENTI RAPIDI",
  "LAVORI CERTIFICATI",
];

export const Ribbon = () => (
  <div
    className="relative z-10 border-y border-[#FFC400]/20 bg-[#0B1F3A] py-4"
    data-testid="marquee-ribbon"
  >
    <Marquee speed={40} gradient={false} autoFill>
      {ITEMS.map((t, i) => (
        <div key={i} className="flex items-center">
          <span className="px-6 font-display text-lg font-extrabold uppercase tracking-widest text-[#FFC400]">
            {t}
          </span>
          <Zap className="h-4 w-4 text-white/40" />
        </div>
      ))}
    </Marquee>
  </div>
);

export default Ribbon;
